import { getTimelineEntryDate } from '../../../services/timeline/dateUtils';
import { getCalendarDateKey } from '../../../utils/calendarDateKey';
import { isManualNoteSourceEntry } from './sourceCaptureReceipt';

const getExplicitOccurredOnDate = (entry = {}) => String(
  entry.occurredOnDate
  || entry.metadata?.timelinePlanner?.occurredOnDate
  || ''
).trim();

const parseDateKey = (dateKey = '') => {
  const parsed = dateKey ? new Date(`${dateKey}T12:00:00`) : null;
  return parsed instanceof Date && !Number.isNaN(parsed.getTime()) ? parsed : null;
};

export const placeManualStoryOnTimelineDate = (item = {}, selectedDateKey = '') => {
  if (item.kind !== 'source_story' || !selectedDateKey) {
    return item;
  }

  const scenes = item.sourceStoryScenes || [];
  const isManualStory = scenes.length > 0 && scenes.every(isManualNoteSourceEntry);
  const hasExplicitHistoricalMoment = scenes.some(getExplicitOccurredOnDate);
  const belongsToSelectedDate = scenes.every(
    (scene) => getCalendarDateKey(getTimelineEntryDate(scene)) === selectedDateKey
  );

  if (!isManualStory || hasExplicitHistoricalMoment || !belongsToSelectedDate) {
    return item;
  }

  return {
    ...item,
    timestamp: parseDateKey(selectedDateKey),
    entryDayKey: selectedDateKey,
    localDate: selectedDateKey,
  };
};
